import dayjs from "dayjs";
import { getYachtId } from "src/utils";

import { type IUser } from "../../components/shared/UserList/UserList.types";
import {
  type ISearchForm,
  type ISearchFormWithUndefined,
  type ISearchResult,
} from "./SearchPage.types";

export const searchInitialValues: ISearchForm = {
  sort: "desc",
  startDate: null,
  endDate: null,
  explicit: "",
  mention: "",
  opened: "",
  status: "*",
  sub: false,
  urn: "",
  ssort: null,
  sdir: null,
  type: "",
};

export const mapSearchUsers = (data: any) => {
  const names = (data.data
    ? data.data.map((user: IUser) => {
        if (user.full_name) {
          return user.full_name;
        }
        if (user.firstname && user.surname) {
          return `${user.firstname} ${user.surname}`;
        }
        return "";
      })
    : []) as string[];

  return [...new Set(names)];
};

export const mapSearchResults = (data: any) =>
  (Array.isArray(data.data)
    ? data.data
    : Object.values(data.data)) as ISearchResult[];
export const getParams = ({
  sort,
  startDate,
  endDate,
  ...rest
}: ISearchFormWithUndefined) => ({
  asc: sort === "asc",
  desc: sort === "desc",
  startDate: startDate ? dayjs(startDate).format("DD/MM/YYYY") : null,
  endDate: endDate ? dayjs(endDate).format("DD/MM/YYYY") : null,
  yachtid: getYachtId(),
  ...rest,
});
